export enum ProactiveEngineStateEnum {
  Activated = 'activated',
  Deactivated = 'deactivated',
  Unavailable = 'unavailable',
}

export enum DeviceAllowedActions {
  PowerOn = 'powerOn',
  PowerOff = 'powerOff',
}

export enum OnOffEnum {
  On = 'on',
  Off = 'off',
}

export enum interestedPackageEnum {
  SYSTEM_CONTROL = 'System Control',
  DYNAMIC_CONTROL = 'Dynamic Control',
  PRESSURE_DROP = 'Pressure Drop',
  ADDITIONAL_SENSORS = 'Additional Sensors',
  ADDITIONAL_COMPRESSORS = 'Additional Compressors',
  SENSOR_PACKAGE = 'Sensor Package',
  CONTROL_CENTER = 'Control Center',
  KNOW_SYSTEM_OFFERING = 'KNOW System offering',
}

export enum DeviceConnectivity {
  NoState = 'noState',
  Disconnected = 'disconnected',
  ConfigurationFailed = 'wrongDeviceConfiguration',
  Connected = 'connected',
  PortDoesNotExist = 'portDoesNotExist',
  DeviceNotResponding = 'deviceNotResponding',
  DeviceChecksumError = 'deviceChecksumError',
}

export enum ControlModeEnum {
  Controllable = 'controllable',
  OnOff = 'onOff',
  NotControllable = 'notControllable',
}

export enum DeviceConnectionTypeEnum {
  IO = 'io',
  Controller = 'controller',
  'N/A' = 'n/a',
}

export enum CompressorActivityStateEnum {
  Off = 'off',
  Load = 'load',
  Unload = 'unload',
}

export enum CompressorExtendedActivityEnum {
  FullLoad = 'fullLoad',
  Unload = 'unload',
  ManualStop = 'manualStop',
  RemoteStop = 'remoteStop',
  Starting = 'starting',
  Stopping = 'stopping',
  EmergencyStop = 'eStop',
  Standby = 'standby',
  Modulation = 'modulation',
  Trim = 'trim',
}

export enum RefrigeratedAirDryerActivityState {
  OFF = 'off',
  ON = 'on',
}

export enum AlertLevels {
  Service = 'service',
  Warning = 'warning',
  Shutdown = 'shutdown',
  Internal = 'internal',
  All = 'all',
}

export enum AlertTypes {
  Active = 'active',
  Archived = 'archived',
}

export enum AlertStatus {
  Open = 'open',
  Close = 'close',
}

export enum DefaultSetpointsOption {
  None = 'none',
  Baseline = 'baseline',
  Custom = 'custom',
}

export enum InsightType {
  Risk = 'risk',
  Maintenance = 'maintenance',
  Energy = 'energy',
}

export enum InsightStatus {
  Draft = 'draft',
  Open = 'open',
  InProgress = 'inProgress',
  Done = 'done',
  Archived = 'archived',
  Reject = 'reject',
  RejectedByCustomer = 'rejectedByCustomer',
}

export enum CurrencySymbol {
  USD = '$',
  EUR = '€',
  ARS = '$',
  AUD = 'A$',
  BRL = 'R$',
  CAD = 'C$',
  CHF = 'CHF',
  CLP = '$',
  CNY = '¥',
  COP = '$',
  CZK = 'Kč',
  DKK = 'kr',
  HKD = 'HK$',
  HUF = 'Ft',
  INR = '₹',
  JPY = '¥',
  KES = 'KSh',
  KRW = '₩',
  MXN = '$',
  MYR = 'RM',
  NIS = '₪',
  NOK = 'kr',
  NZD = 'NZ$',
  PHP = '₱',
  RUB = '₽',
  SEK = 'kr',
  SGD = 'S$',
  THB = '฿',
  UAH = '₴',
  VND = '₫',
  ZAR = 'R',
}

export enum UnitMeasurementSystem {
  Imperial = 'imperial',
  Metric = 'metric',
}

export enum IdPAuthenticationType {
  Password = 'password',
  Azure = 'azure',
  Okta = 'okta',
}

export enum PackageCareAbleOptions {
  NoCareProgram = 'nocareprogram',
  NotCareAble = 'notcareable',
}

export enum StationTier {
  Asset = 0,
  Monitor = 1, // was System before
  SimpleControl = 2,
  Optimize = 3, // was DynamicControl before
}

export enum AlertRuleTypes {
  MANUFACTURER = 'MANUFACTURER',
  CUSTOM = 'CUSTOM',
}

export enum SensorsPackage {
  Power = 'Power',
  Flow = 'Flow',
  Pressure = 'Pressure',
  DewPoint = 'Dew Point',
  SpecificPower = 'Specific Power',
}

export enum ComponentTierName {
  CompressorView = 'CompressorView',
  StationTotalCollapsible = 'StationTotalCollapsible',
  PressureControlView = 'PressureControlView',
  StationControlCenterView = 'StationControlCenterView',
  ControlCenterKPIs = 'ControlCenterKPIs',
  CreateNewCompressor = 'CreateNewCompressor',
  TrendsView = 'TrendsView',
  MapView = 'MapView',
  EnergySavingsWidget = 'EnergySavingsWidget',
  InvestigationDashboard = 'InvestigationDashboard',
  Insights = 'Insights',
  Leakage = 'Leakage',
  SystemHealth = 'SystemHealth',
  SystemHealthAsset = 'SystemHealthAsset',
  PaymentPlan = 'PaymentPlan',
  ProactiveEngine = 'ProactiveEngine',
  ProactiveEngineCommandsLog = 'ProactiveEngineCommandsLog',
  CompressorModalInfoIcons = 'CompressorModalInfoIcons',
  AddNewController = 'AddNewController',
  TrendsViewMockAsset = 'TrendsViewMockAsset',
  StationRiskMock = 'StationRiskMock',
  CompressorModalLockButton = 'CompressorModalLockButton',
}

export enum LanguageEnum {
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  PT = 'pt',
  DE = 'de',
}

export enum DeviceKind {
  Controlled = 'Controlled',
  NoController = 'NoController',
  Disconnected = 'Disconnected',
  Proxy = 'Proxy',
  Virtual = 'Virtual',
}

export enum EnvironmentEnum {
  Production = 'production',
  Staging = 'staging',
  QA = 'qa',
  QA2 = 'qa2',
  Development = 'development',
  Local = 'local',
}

export enum StationStageName {
  Subscription = 'Subscription',
  Deprecated = 'Deprecated',
  // Add other stage names as needed
}

export enum DataType {
  Metric = 'metric',
  PressureDrop = 'pressureDrop',
}

export enum DeviceAction {
  InMaintenance = 'inMaintenance',
  PowerOnOff = 'powerOnOff',
}
